// import { utils, Store, request } from "@hysfront/static"
import utils from '@/public/utils';
import Store from '@/public/utils/store';
import { payReq } from '@/api/index';
const app = {
    payInfo(jsApiParameters) {
        const onBridgeReady = () => {
            WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiParameters, res => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                    this.paySuccess();
                }
                else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                    this.payPopup();
                }
                else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                    this.$toast('支付失败，请稍后或重新尝试支付！');
                }
            });
        };
        if (typeof WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            }
            else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        }
        else {
            onBridgeReady();
        }
    },
    pagePay(params, query) {
        if (utils.weixin()) {
            app.wxPay.call(this, params, query);
        }
        else {
            app.aliPay.call(this, params, query);
        }
    },
    // 支付宝支付
    aliPay(params, query) {
        document.querySelector('.aliFormBox') &&
            document.querySelector('.aliFormBox').remove();
        payReq.getAliPaySign({ params, query }).then(res => {
            const data = res;
            this.$hideLoading();
            if (res.code === 200 && data) {
                const div = document.createElement('div');
                div.setAttribute('class', 'aliFormBox');
                /* 此处form就是后台返回接收到的数据 */
                div.innerHTML = data.data;
                document.body.appendChild(div);
                document.forms[0].submit();
            }
            else {
                this.$toast(res.message);
            }
        });
    },
    wxPay(params, query) {
        const openId = Store.get('openId', 'local');
        if (!openId) {
            this.$hideLoading();
            this.$toast('缺少参数openId');
            return;
        }
        payReq.getWechatSign({ params, query }).then(res => {
            this.$hideLoading();
            if (res.code === 200) {
                const { appId, timeStamp, nonceStr, packageValue, signType, paySign } = res;
                app.payInfo.call(this, {
                    appId,
                    timeStamp,
                    nonceStr,
                    package: packageValue,
                    signType,
                    paySign
                });
            }
            else {
                this.$toast(res.message);
            }
        });
    },
    postMessage({ type, id = '', orderId, url, tab }) {
        // operation_detail 训练营详情
        // mall_detail  商城详情
        // open_detail  公开课详情
        // vip_member_open  开通会员
        // article_detail  文章详情
        // pbl_discuss_create pbl话题创建
        // image_preview
        // live_stream_detail 直播
        const data = {
            typeId: type,
            dataId: id
        };
        if (orderId) {
            data.orderId = orderId;
        }
        if (url) {
            data.url = url;
        }
        if (tab) {
            data.type = tab;
        }
        if (utils.android()) {
            window.JavaScriptInterface.jumpModule(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.jumpModule.postMessage(data);
        }
    },
    imagePreview({ type, images, posIndex }) {
        let imgs = JSON.parse(JSON.stringify(images));
        const data = {
            typeId: type,
            images: imgs,
            posIndex
        };
        // console.log(data)
        if (utils.android()) {
            window.JavaScriptInterface.jumpModule(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.jumpModule.postMessage(data);
        }
    },
    callPhone(telphone) {
        if (utils.android()) {
            window.JavaScriptInterface.tellPhone(String(telphone));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.CallCustomerService.postMessage(telphone);
        }
    },
    mobileApi(data) {
        if (utils.android()) {
            window.JavaScriptInterface.mobileApi(JSON.stringify(data));
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.mobileApi.postMessage(data);
        }
    },
    backHome() {
        if (utils.android()) {
            window.JavaScriptInterface.goMainHome();
        }
        else if (utils.ios()) {
            window.webkit.messageHandlers.mineTeachetBackHome.postMessage('');
        }
    },
    webViewBack() {
        this.mobileApi({ type: 'webViewBack' });
    },
    appShare(data, type = 'share') {
        // shareWechat 微信好友
        // shareFriend 朋友圈
        this.mobileApi({ type, data: { ...data } });
    },
    // APP 中使用微信、支付宝支付
    appPay({ platform, module, orderId }) {
        this.$showLoading();
        payReq
            .getAppPaySign({
            platform,
            module,
            type: 'app'
        }, {
            orderId
        })
            .then(res => {
            this.$hideLoading();
            if (res.code === 200 && res.data) {
                let source = { type: platform, sign: res.data };
                if (utils.android()) {
                    window.JavaScriptInterface.bojuPay(JSON.stringify(source));
                }
                else if (utils.ios()) {
                    window.webkit.messageHandlers.bojuPay.postMessage(source);
                }
            }
            else {
                this.$toast(res.message);
            }
        });
    }
};
export default app;
